import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  direction: "ltr",
  components: {
    MuiAvatar: {
      styleOverrides: {
        fallback: {
          height: "75%",
          width: "75%",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          boxSizing: "border-box",
        },
        html: {
          MozOsxFontSmoothing: "grayscale",
          WebkitFontSmoothing: "antialiased",
          height: "100%",
          width: "100%",
        },
        body: {
          height: "100%",
        },
        "#root": {
          height: "100%",
        },
        "#nprogress .bar": {
          zIndex: "2000 !important",
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {},
    },
  },
  typography: {
    fontFamily: `'Lato', Helvetica, sans-serif`,
    h1: {
      //title
      fontSize: "65px",
      fontWeight: "inherit",
      fontStyle: "inherit",
    },
    h2: {
      //sub-title
      fontSize: "40px",
      fontWeight: "inherit",
      fontStyle: "inherit",
    },
    h3: {
      fontSize: "25px",
      fontWeight: 400,
      fontStyle: "normal",
    },
    h4: {
      fontSize: "20px",
      fontWeight: 500,
      fontStyle: "bold",
    },
    h5: {
      fontSize: "18px",
      fontWeight: 400,
      fontStyle: "normal",
    },
    subtitle1: {
      //error
      fontSize: "12px",
      fontWeight: "400",
      fontStyle: "normal",
    },
    subtitle2: {
      fontSize: "16px",
      fontWeight: 300,
      fontStyle: "italic",
    },
    body1: {
      //normal
      fontSize: "16px",
      fontWeight: "inherit",
      fontStyle: "inherit",
    },
    body2: {
      fontSize: "16px",
      fontWeight: 400,
      fontStyle: "normal",
    },
    button: {
      fontWeight: 600,
    },
    caption: {
      fontSize: "14px",
      fontWeight: 400,
      fontStyle: "normal",
      textTransform: "none",
    },
    overline: {
      fontWeight: 500,
    },
  },
  palette: {
    primary: {
      main: "#26549e", // primary blue
      contrastText: "#FFFFFF", // white
    },
    secondary: {
      main: "#6c23a8", // purple
      contrastText: "#ffffff", // white
    },
    tertiary: {
      main: "#e3c900", // yellow
      contrastText: "#fff", // white
    },
    error: {
      main: "#ad221d", // red
      contrastText: "#FFFFFF", // white
    },
    warning: {
      main: "#d47b0f", // orange
      contrastText: "#000", // black
    },
    info: {
      main: "#65a1bf", // gray blue
      contrastText: "#fff", // white
    },
    success: {
      main: "#368733", // green
      contrastText: "#000", // black
    },
    background: {
      default: "#c2c7cc", // light gray
      paper: "#FFFFFF", // white
    },
    text: {
      primary: "#3a3b3c", // Dark gray
      secondary: "#787a7d", // gray
    },
    divider: "#777777", // "rgba(145, 158, 171, 0.24)",
    quarternary: {
      main: "#ffe4d2", // darker light orange
      contrastText: "#ffffff", // white,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  shape: {
    borderRadius: 5,
  },
});

export default theme;

declare module "@mui/material/styles" {
  interface Palette {
    tertiary: Palette["primary"];
    quarternary: Palette["primary"];
  }
  interface PaletteOptions {
    tertiary?: PaletteOptions["primary"];
    quarternary?: PaletteOptions["primary"];
  }
}
